import { updateAggregations } from 'core/modules/list/utils/aggregations';

export const receiveProductsAggregations = (state, { payload }) =>
  state.withMutations((newState) => {
    updateAggregations(newState, payload, { withCounts: false });
  });
